/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查询用户场次是否提醒
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  productId: number,
  saleBeginTime: number,
  showId: number,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: member.ProductSaleShowRemindDTO;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/project/${productId}/${saleBeginTime}/${showId}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
